// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_GENERAL_INWARD_REQUEST_DK = 'FETCH_GENERAL_INWARD_REQUEST_DK';
export const FETCH_GENERAL_INWARD_SUCCESS_DK = 'FETCH_GENERAL_INWARD_SUCCESS_DK';
export const FETCH_GENERAL_INWARD_FAILURE_DK = 'FETCH_GENERAL_INWARD_FAILURE_DK';

export const FETCH_PENDING_GENERAL_PO_IN_INWARD_REQUEST_DK = 'FETCH_PENDING_GENERAL_PO_IN_INWARD_REQUEST_DK';
export const FETCH_PENDING_GENERAL_PO_IN_INWARD_SUCCESS_DK = 'FETCH_PENDING_GENERAL_PO_IN_INWARD_SUCCESS_DK';
export const FETCH_PENDING_GENERAL_PO_IN_INWARD_FAILURE_DK = 'FETCH_PENDING_GENERAL_PO_IN_INWARD_FAILURE_DK';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_GENERAL_INWARD_REQUEST_DK = 'CREATE_GENERAL_INWARD_REQUEST_DK';
export const CREATE_GENERAL_INWARD_SUCCESS_DK = 'CREATE_GENERAL_INWARD_SUCCESS_DK';
export const CREATE_GENERAL_INWARD_FAILURE_DK = 'CREATE_GENERAL_INWARD_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_GENERAL_INWARD_DK = 'CREATE_USER_FORM_GENERAL_INWARD_DK';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_GENERAL_INWARD_REQUEST_DK = 'UPDATE_GENERAL_INWARD_REQUEST_DK';
export const UPDATE_GENERAL_INWARD_SUCCESS_DK = 'UPDATE_GENERAL_INWARD_SUCCESS_DK';
export const UPDATE_GENERAL_INWARD_FAILURE_DK = 'UPDATE_GENERAL_INWARD_FAILURE_DK';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_GENERAL_INWARD_REQUEST_DK = 'FETCH_SINGLE_GENERAL_INWARD_REQUEST_DK';
export const FETCH_SINGLE_GENERAL_INWARD_SUCCESS_DK = 'FETCH_SINGLE_GENERAL_INWARD_SUCCESS_DK';
export const FETCH_SINGLE_GENERAL_INWARD_FAILURE_DK = 'FETCH_SINGLE_GENERAL_INWARD_FAILURE_DK';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_GENERAL_INWARD_REQUEST_DK = 'DELETE_GENERAL_INWARD_REQUEST_DK';
export const DELETE_GENERAL_INWARD_SUCCESS_DK = 'DELETE_GENERAL_INWARD_SUCCESS_DK';
export const DELETE_GENERAL_INWARD_FAILURE_DK = 'DELETE_GENERAL_INWARD_FAILURE_DK';

// USERFORM RESET

export const GENERAL_INWARD_USERFORM_RESET_DK = 'GENERAL_INWARD_USERFORM_RESET_DK';

// navigate to unit component
export const NAVIGATE_GENERAL_INWARD_DETAILS_DK = 'NAVIGATE_GENERAL_INWARD_DETAILS_DK';
// navigate to company component
export const NAVIGATE_GENERAL_INWARD_DK = 'NAVIGATE_GENERAL_INWARD_DK';

export const RESET_FORM_DATA_WITHOUT_GENERAL_INWARD_ID_DK = 'RESET_FORM_DATA_WITHOUT_GENERAL_INWARD_ID_DK';
export const SET_ACTIVE_KEY_GENERAL_INWARD_DK = 'SET_ACTIVE_KEY_GENERAL_INWARD_DK';
